import React from 'react';
import Card from '../card/Card';

export default class SummaryCard extends React.Component {
  render() {
    return (
      <Card header={this.props.title}>
        <div className="card-icon">
          <i className={this.props.iconClass} style={{ color: this.props.iconColor }} />
        </div>
        <div className="card-value">
          <span className="number">{this.props.number}</span>
          <span className="suffix">{this.props.unit}</span>
        </div>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/summarycard/SummaryCard.js